module.exports = __webpack_public_path__ + "static/media/arrow-right-blue.31e8114d.svg";